import QRCodeStyling from 'qr-code-styling';

export const startPrint = (
  blobs,
  printPageURL,
  waitingMsg,
  cancelText,
  onWindowOpenFaile,
  watermark,
  qrcode
) => {
  const totalPage = blobs.length;

  const printWindow = window.open(printPageURL);

  if (printWindow === null) {
    onWindowOpenFaile && onWindowOpenFaile();
  } else {
    printWindow.addEventListener('load', () => {
      genQrCodeImage(qrcode).then((imageObj) =>
        printfn(imageObj, printWindow, totalPage, blobs, watermark, waitingMsg,cancelText)(1)
      );
    });
  }
};

const printfn = (imgQR, printWindow, totalPage, blobs, watermarks, waitingMsg, cancelText) => (pageNum) => {
  // let  pageNum  = 0;

  const width = 793; //827;
  const height = 1122; //1169; //1110
  const canvas = window.document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  let timerId = -1;
  if (pageNum > totalPage) {
    printWindow.postMessage({ status: 'end' }, location.origin);
    clearTimeout(timerId);
  } else {
    genImageFromBlob(blobs[pageNum - 1]).then((imgObj, event) => {
      //debugger;

      canvas.width = imgObj.width;
      canvas.height = imgObj.height;
      const isPortrait = imgObj.height > imgObj.width;

      //URL.revokeObjectURL(event.target.src); // 👈 This is important. If you are not using the blob, you should release it if you don't want to reuse it. It's good for memory.
      ctx.drawImage(imgObj, 0, 0);

      if (watermarks) {
        ctx.font = '20px serif';

        if (watermarks.top && watermarks.top.msg) {
          const textMeasureResult = ctx.measureText(watermarks.top.msg);
          ctx.fillText(
            watermarks.top.msg,
            canvas.width / 2 - textMeasureResult.width / 2,

            (textMeasureResult.fontBoundingBoxAscent + textMeasureResult.fontBoundingBoxDescent) *
              1.5
          );
        }

        if (watermarks.bottom && watermarks.bottom.msg) {
          const textMeasureResult = ctx.measureText(watermarks.bottom.msg);
          ctx.fillText(
            watermarks.bottom.msg,
            canvas.width / 2 - textMeasureResult.width / 2,
            canvas.height -
              (textMeasureResult.fontBoundingBoxAscent + textMeasureResult.fontBoundingBoxDescent) *
                1.5
          );
        }
      }

      if (imgQR && pageNum === 1) {
        ctx.drawImage(imgQR, imgQR.width / 2, imgQR.height / 2);
      }

      printWindow.postMessage(
        {
          status: 'progress',
          image: canvas.toDataURL(),
          totalPage: totalPage,
          curPage: pageNum,
          width: isPortrait ? width : height, //width,
          height: isPortrait ? height : width,
          waitingMsg: waitingMsg,
          cancelText
        },
        location.origin
      );

      timerId = setTimeout(
        printfn(imgQR, printWindow, totalPage, blobs, watermarks, waitingMsg,cancelText),
        10,
        pageNum + 1
      );
    });
  }
};

const genQrCodeImage = (qrcode) => {
  return qrcode
    ? genQRCodeInstance(
        120,
        120,
        'https://edu.polarisoffice.com/',
        {
          image: '/favicon.ico',
          imageOptions: {
            crossOrigin: 'anonymous',
            margin: 1
          }
        },
        genDotsOptionsAsGradient('extra-rounded', '#85b7f8', '#509BFD')
        //genDotsOptionsAsGradient('extra-rounded', '#85b7f8', '#fc0262'),
      )
        .getRawData('png')
        .then((rawBlob) => genImageFromBlob(rawBlob))
    : Promise.resolve(undefined, undefined);
};

const genDotsOptionsAsGradient = (type, color1, color2) => {
  return {
    type,
    gradient: {
      type: 'radial',
      colorStops: [
        {
          offset: 0.4,
          color: color1
        },
        {
          offset: 1,
          color: color2
        }
      ]
    }
  };
};

const genQRCodeInstance = (width, height, data, centerImageImages, dotsOptions) => {
  const qrcode = new QRCodeStyling({
    data,
    width,
    height,
    ...(centerImageImages ? centerImageImages : {}),
    dotsOptions
  });

  return qrcode;
};

const genImageFromBlob = (blob) => {
  return new Promise((resolve, reject) => {
    const imgQR = new Image();
    imgQR.onload = (event) => {
      URL.revokeObjectURL(event.target.src);
      resolve(imgQR, event);
    };

    imgQR.onerror = () => {
      URL.revokeObjectURL(imgQR.src);
      reject();
    };
    imgQR.src = URL.createObjectURL(blob);
  });
};
